import { render, staticRenderFns } from "./AutocompletePatient.vue?vue&type=template&id=65814cd0&"
import script from "./AutocompletePatient.vue?vue&type=script&lang=js&"
export * from "./AutocompletePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports